module.exports = __webpack_public_path__ + "static/media/logo.57b30c28.png";